import { useMemo as e } from "react";
import { useTranslation as t } from "react-i18next";
//#region src/permissions/usePermissionGroups.ts
var n = {
	properties: "properties",
	experiences: "experiences",
	services: "services",
	bookings: "bookings",
	reservations: "reservations",
	finance: "finance",
	workspace: "workspace",
	pricing: "pricing",
	booking_rules: "bookingRules",
	calendar: "calendar",
	travel_guides: "travelGuides",
	coupons: "coupons",
	chat: "chat",
	automated_messages: "automatedMessages",
	pbac: "pbac",
	verification: "verification",
	guest_documents: "guestDocuments",
	developer: "developer",
	reports: "reports",
	front_desk: "frontDesk",
	rooms: "frontDesk",
	housekeeping: "frontDesk"
}, r = (r, i) => {
	let { t: a } = t("workspace");
	return e(() => {
		let e = /* @__PURE__ */ new Map();
		for (let t of r) {
			let r = i(t).split(".")[0], a = n[r] ?? r, o = e.get(a);
			o ? (o.items.push(t), r.localeCompare(o.sortKey) < 0 && (o.sortKey = r)) : e.set(a, {
				sortKey: r,
				items: [t]
			});
		}
		return [...e.entries()].sort(([, e], [, t]) => e.sortKey.localeCompare(t.sortKey)).map(([e, t]) => ({
			domain: e,
			label: a(`permissionPicker.groups.${e}`, { defaultValue: e }),
			items: t.items
		}));
	}, [r, a]);
};
//#endregion
export { r as usePermissionGroups };
